<template>
  <div v-if="hasKKMRight" class="mb-3">
    <b-button class="btn-collapse"
              v-spaceduck-collapse="`collapse-kkm`">
      KKM
    </b-button>
    <spaceduck-collapse id="collapse-kkm">
      <div class="pt-4 pb-4" v-if="initiated">
        <CheckboxGroup :label="$t('on')"
                       checkboxvalue="1"
                       fid="kkm"
                       v-model="kkm.kkm_enabled"/>
        <div class="pt-3" v-if="kkm.kkm_enabled">
          <InputGroup v-model="kkm.kkm_url"
                      class="mb-3"
                      label="Url">
            <div class="text-muted small">{{ $t('kkm_url') }}</div>
          </InputGroup>
          <InputGroup v-model="kkm.kkm_service"
                      class="mb-3"
                      :label="$t('name_of_service_in_cheque')"/>
          <InputGroup v-model="kkm.kkm_clinic_name"
                      class="mb-3"
                      :label="$t('clinic_name_in_cheque')"/>

          <SelectGroup :options="kkmCashierTypes"
                       :label="$t('cashier')"
                       :null-option="false"
                       class="mb-3"
                       variant="white"
                       :showlabel="true"
                       v-model="kkm.kkm_cashier_type"/>

          <div v-if="kkm.kkm_cashier_type === 'fixed'" class="bg-gray py-3 px-4 mb-2">
            <InputGroup v-model="kkm.kkm_cashier_name"
                        class="mb-3"
                        :label="$t('cashier_name')"/>
            <InputGroup v-model="kkm.kkm_cashier_inn"
                        class="mb-3"
                        :label="$t('cashier_inn')"/>
          </div>

          <ServiceMultiSelect :label="$t('pay_methods_cash')"
                              :dblclick="false"
                              model="pay_method"
                              title="translatedTitle"
                              class="mb-3"
                              :dbsearch="false"
                              :prepopulatedOptions="pay_methods"
                              v-model="kkm.kkm_cashmethods"/>
          <ServiceMultiSelect :label="$t('pay_methods_acquiring')"
                              :dblclick="false"
                              model="pay_method"
                              title="translatedTitle"
                              class="mb-3"
                              :dbsearch="false"
                              :prepopulatedOptions="pay_methods"
                              v-model="kkm.kkm_acquiring_methods"/>
          <!--          <InputGroup v-model="kkm.kkm_inn"-->
          <!--                      class="mb-3"-->
          <!--                      :label="$t('inn')">-->
          <!--            <div class="small text-muted">{{ $t('only_for_payment_through_terminal') }}</div>-->
          <!--          </InputGroup>-->
          <SelectGroup :options="kkmTaxModes"
                       :label="$t('vat_rate')"
                       class="mb-3"
                       variant="white"
                       :showlabel="true"
                       v-model="kkm.kkm_vat"/>
          <SelectGroup :options="kkmAdvanceTypes"
                       :label="$t('process_advances_as')"
                       :null-option="false"
                       class="mb-3"
                       variant="white"
                       :showlabel="true"
                       v-model="kkm.kkm_advance"/>
          <CheckboxGroup :label="$t('send_services_in_cheque')"
                         fid="kkm_send_services"
                         class="mb-3"
                         checkboxvalue="1"
                         v-model="kkm.kkm_send_services"/>
        </div>
        <div class="mt-4">
          <button class="btn btn-themed btn-themed-squared"
                  :disabled="loading"
                  @click="saveWebkassa">
            {{ $t('save') }}
          </button>
        </div>
      </div>
    </spaceduck-collapse>
  </div>
</template>

<script setup>
import { ClinicService } from "@/services/api/clinic.api.service"
import { useStore} from "vuex"
import InputGroup from "@/components/form/InputGroup.vue"
import ServiceMultiSelect from "@/components/form/ServiceMultiSelect.vue"
import SpaceduckCollapse from "@/components/parts/general/SpaceduckCollapse.vue"
import CheckboxGroup from "@/components/form/CheckboxGroup.vue"
import SelectGroup from "@/components/form/SelectGroup.vue"
import {kkmAdvanceTypes, kkmTaxModes, kkmCashierTypes} from "@/dictionaries/dictionary"
import {computed, getCurrentInstance, onBeforeMount, onMounted, ref} from "vue"

const store = useStore()
const dynamicConfigValue = store.getters.dynamicConfigValue
let i18n = null
let noty = null

const emit = defineEmits(['update'])

const rights = computed(() => store.state.auth.rights)
const clinic = computed(() => store.state.auth.clinic)
const superadmin = computed(() => store.state.auth.superadmin)
const loading = computed(() => store.state.dom.loading)
const pay_methods = computed(() => store.state.auth.pay_methods)
const branch = computed(() => store.state.auth.branch)
const hasKKMRight = computed(() => rights.value.includes('kkm'))

const kkm = ref({
  kkm_enabled: '',
  kkm_send_services: 0,
  kkm_service: '',
  kkm_clinic_name: '',
  kkm_inn: '',
  kkm_cashmethods: '',
  kkm_acquiring_methods: '',
  kkm_vat: '',
  kkm_url: '',
  kkm_advance: 'advance',
})
const initiated = ref(false)

const saveWebkassa = async () => {
  await ClinicService.saveDynamicConfigs([
    {
      id: 'kkm_enabled',
      value: kkm.value.kkm_enabled,
      subgroup: 'kkm',
      branchId: branch.value
    },
    {
      id: 'kkm_send_services',
      value: kkm.value.kkm_send_services,
      subgroup: 'kkm',
      branchId: branch.value
    },
    {
      id: 'kkm_service',
      value: kkm.value.kkm_service,
      subgroup: 'kkm',
      branchId: branch.value
    },
    {
      id: 'kkm_clinic_name',
      value: kkm.value.kkm_clinic_name,
      subgroup: 'kkm',
      branchId: branch.value
    },
    {
      id: 'kkm_cashier_name',
      value: kkm.value.kkm_cashier_name,
      subgroup: 'kkm',
      branchId: branch.value
    },
    {
      id: 'kkm_cashier_inn',
      value: kkm.value.kkm_cashier_inn,
      subgroup: 'kkm',
      branchId: branch.value
    },
    {
      id: 'kkm_inn',
      value: kkm.value.kkm_inn,
      subgroup: 'kkm',
      branchId: branch.value
    },
    {
      id: 'kkm_cashmethods',
      value: kkm.value.kkm_cashmethods.map(x => x.id),
      subgroup: 'kkm',
      branchId: branch.value
    },
    {
      id: 'kkm_acquiring_methods',
      value: kkm.value.kkm_acquiring_methods.map(x => x.id),
      subgroup: 'kkm',
      branchId: branch.value
    },
    {
      id: 'kkm_vat',
      value: kkm.value.kkm_vat,
      subgroup: 'kkm',
      branchId: branch.value
    },
    {
      id: 'kkm_url',
      value: kkm.value.kkm_url,
      subgroup: 'kkm',
      branchId: branch.value
    },
    {
      id: 'kkm_advance',
      value: kkm.value.kkm_advance,
      subgroup: 'kkm',
      branchId: branch.value
    },
    {
      id: 'kkm_cashier_type',
      value: kkm.value.kkm_cashier_type,
      subgroup: 'kkm',
      branchId: branch.value
    },
  ], superadmin.value, clinic.value.id)

  noty.info(i18n.t('success_message'))
  emit('update')
}

onBeforeMount(() => {
  const instance = getCurrentInstance()
  i18n = instance?.ctx?.$i18n
  noty = instance?.appContext?.app?.noty
})


onMounted(() => {
  kkm.value.kkm_enabled = dynamicConfigValue('kkm_enabled', branch.value) || 0
  kkm.value.kkm_send_services = dynamicConfigValue('kkm_send_services', branch.value) || 0
  kkm.value.kkm_service = dynamicConfigValue('kkm_service', branch.value)
  kkm.value.kkm_clinic_name = dynamicConfigValue('kkm_clinic_name', branch.value)
  kkm.value.kkm_cashier_name = dynamicConfigValue('kkm_cashier_name', branch.value)
  kkm.value.kkm_cashier_inn = dynamicConfigValue('kkm_cashier_inn', branch.value)
  kkm.value.kkm_inn = dynamicConfigValue('kkm_inn', branch.value)
  kkm.value.kkm_vat = dynamicConfigValue('kkm_vat', branch.value)
  kkm.value.kkm_url = dynamicConfigValue('kkm_url', branch.value)
  kkm.value.kkm_advance = dynamicConfigValue('kkm_advance', branch.value) || 'advance'
  kkm.value.kkm_cashier_type = dynamicConfigValue('kkm_cashier_type', branch.value) || 'auto'
  kkm.value.kkm_cashmethods = []
  let cashMethods = dynamicConfigValue('kkm_cashmethods', branch.value)
  if(cashMethods) kkm.value.kkm_cashmethods = pay_methods.value.filter(p => cashMethods.includes(p.id))
  kkm.value.kkm_acquiring_methods = []
  let acquiringMethods = dynamicConfigValue('kkm_acquiring_methods', branch.value)
  if(acquiringMethods) kkm.value.kkm_acquiring_methods = pay_methods.value.filter(p => acquiringMethods.includes(p.id))
  initiated.value = true
})
</script>
